import React from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PageLayout from 'components/PageLayout';

const AuthorizedRoute = ({ component: Component, ...rest }) => ( // eslint-disable-line react/prop-types
  <Route
    {...rest}
    render={(props) => (
      <PageLayout>
        <Component {...props} />
      </PageLayout>
    )}
  />
);

const mapStateToProps = (state) => ({
  apiVersion: state.Global.apiVersion,
});

export default connect(mapStateToProps)(AuthorizedRoute);
